export default [
  {
    path: '/importacoes-bdgd',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Importações BDGD Histórico',
        path: '',
        component: () => import('@/views/importacoesBdgd/Index.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'Importações BDGD' }]
        }
      },
      {
        name: 'Importações BDGD Adicionar',
        path: 'add',
        component: () => import('@/views/importacoesBdgd/Add.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Dados', path: '/dados' },
            { name: 'Importações BDGD', path: '/importacoes-bdgd/' },
            { name: 'Adicionar' }
          ]
        }
      }
    ]
  }
];
